import { FormProvider, useForm } from 'react-hook-form';

const FormContainer = ({
  onSuccess,
  onError,
  FormProps,
  defaultValues,
  children,
  ...rest
}) => {
  const methods = useForm({
    defaultValues,
    shouldUnregister: true,
    ...rest,
  });

  const submitForm = () =>
    methods.handleSubmit(
      onSuccess ?? (() => console.warn('onSuccess is missing')),
      onError,
    )();

  return (
    <FormProvider {...methods}>
      {children({ ...methods, submitForm })}
    </FormProvider>
  );
};

export default FormContainer;
